import { h, Component } from 'preact';
import Three from '../../gemThree/gemThree';
import Loadingbar from '../../../loadingbar/loadingbar';
import ZoomControls from '../../gemZoomControls/zoomcontrols';
import config from '../../../../config/config.json';
import cn from 'classnames';
import s from '../scss/gemComponentsView.scss';

export default class GemInteriorView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: {
        imagesLoaded: 0,
        isLoaded: false,
        percentLoaded: 0
      },
      zooming: 0.5,
      zoom: true
    };
    this.getVPwidth();

    this.setUrlParams();
  }

  componentDidMount() {
    window.addEventListener('orientationchange', this.getVPwidth);
    window.addEventListener('resize', this.getVPwidth);
  }

  componentWillUnmount() {
    window.removeEventListener('orientationchange', this.getVPwidth);
    window.removeEventListener('resize', this.getVPwidth);
  }

  setUrlParams = () => {
    // all Carline and Request stuff are set to state
    const url = window.location.href.split('?')[0];
    // remove index.html if in url
    const noIndex = url.replace('index.html', '');
    // regex to find the correct parameters to build imagePath
    const path_regex = new RegExp(
      /([A-Z]{2})\/([a-z]{2})\/([A-Z]{2})\/([A-Z|a-z]*)\/([a-z|A-Z|_]{5,10})/
    );
    const params = url.split(path_regex);

    // console.log('PARAMS', params)
    const country = params[1];
    const lang = params[2];
    const carline = params[4];
    const bodystyle = params[5];
    const mobile = params[6];
    const imgPath =
      country +
      '/' +
      lang +
      '/' +
      params[3] +
      '/' +
      params[4] +
      '/' +
      bodystyle +
      mobile + '/';
    const absPath =
      process.env.NODE_ENV === 'production'
        ? noIndex
        : `${window.location.origin}/`;

    const clearMobileParam = mobile.split("/")

    this.setState({
      imgPath,
      carline,
      country,
      lang,
      absPath,
      mobile: clearMobileParam[1] === 'mobile' ? clearMobileParam[1] : ''
    });
    const marketConfig = config.array.find(
      market => market.market === `${country}_${lang}`
    );
    marketConfig &&
      marketConfig[carline] &&
      this.getConfig(marketConfig[carline]);
    if (this.isInteriorOnly) {
      this.setState({
        showtext: marketConfig.text.menushowtext,
        hidetext: marketConfig.text.menuhidetext
      });
    }
  };

  getConfig = marketConfig => {
    // find defaultThumb Index
    const defaultThumbIndex = marketConfig.findIndex(thumb => thumb.default);
    // set defaultThumb to state
    // get carline config from market
    this.setState({
      interior: {
        config: marketConfig,
        index: defaultThumbIndex
      }
    });
  };

  getVPwidth = () => {
    this.setState({
      vw: Math.max(
        document.documentElement.clientWidth,
        window.innerWidth || 0
      ),
      vh: Math.max(
        document.documentElement.clientHeight,
        window.innerHeight || 0
      )
    });
  };

  loadHandling = amount => {
    const { loading } = this.state;
    this.setState({
      loading: {
        imagesLoaded: loading.imagesLoaded + 1,
        percentLoaded: (100 / amount) * (loading.imagesLoaded + 1),
        isLoaded: (100 / amount) * (loading.imagesLoaded + 1) === 100
      }
    });
  };

  resetLoad = () => {
    this.setState({
      loading: {
        imagesLoaded: 0,
        isLoaded: false
      }
    });
  };

  get isInteriorOnly() {
    const { carline } = this.state;
    return (
      carline === 'onix'
    );
  }

  handleZoomClicked = factor => {
    this.setState({ zooming: factor, zoom: !this.state.zoom });
  };

  handleZoomStopped = () => {
    this.setState({ zooming: 0 });
  };

  render() {
    const {
      absPath,
      imgPath,
      interior,
      lang,
      loading,
      vw,
    } = this.state;
    const size = document.body.offsetHeight;
    let input;
    if (this.isInteriorOnly) {
      input = (
        <div
          id="interior"
        >
          <div class={s.threesixtyIcon}/>
           {!this.state.mobile && <ZoomControls
            zoomClicked={this.handleZoomClicked}
            zoomFactor={this.state.zooming}
            zoomStatus={this.state.zoom}
          />}

          <Three
            stageWidth={vw}
            stageHeight={size}
            loadHandling={this.loadHandling}
            imgPath={imgPath}
            interior={interior}
            absPath={absPath}
            zoomStopped={this.handleZoomStopped}
            zoomFactor={this.state.zooming}
            isInteriorOnly={this.isInteriorOnly}
            carline={this.state.carline}
          />
        </div>
      );
    }

    return (
      <div id="app">
        {loading.percentLoaded < 100 && (
          <Loadingbar percent={loading.percentLoaded} />
        )}
        {input}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/gemView/gemComponentsView/gemInteriorView/GemInteriorView.js